import React from 'react';
import logo from '../assets/logo.png';

function Header({ onCartClick, onMenuClick }) {
  return (
    <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 64, position: 'relative', marginBottom: 24 }}>
      <button onClick={onCartClick} style={iconBtnStyle} aria-label="Cart">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="15 18 9 12 15 6" />
        </svg>
      </button>
      <div style={{ position: 'absolute', left: 0, right: 0, textAlign: 'center', pointerEvents: 'none' }}>
        <img src={logo} alt="logo" style={{ height: 100 }} />
      </div>
      <button onClick={onMenuClick} style={iconBtnStyle} aria-label="Menu">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 12L12 3l9 9" />
          <path d="M9 21V12h6v9" />
        </svg>
      </button>
    </div>
  );
}

const iconBtnStyle = {
  background: 'none',
  border: 'none',
  padding: 0,
  margin: 0,
  cursor: 'pointer',
  width: 40,
  height: 40,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export default Header; 